import { useCallback, useEffect, useRef } from "react"

const SCRIPT_SELECTOR = 'script[src*="enterprise.js"]'

export function useRecaptcha() {
  const ready = useRef(false)

  useEffect(() => {
    const siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY as string
    if (!siteKey) return
    const existing = document.querySelector(SCRIPT_SELECTOR)
    if (existing) {
      ready.current = true
      return
    }
    const script = document.createElement("script")
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${siteKey}`
    script.async = true
    script.onload = () => {
      ready.current = true
    }
    document.head.appendChild(script)
    return () => {
      if (document.head.contains(script)) document.head.removeChild(script)
      ready.current = false
    }
  }, [])

  const getToken = useCallback(async (action: string): Promise<string> => {
    const siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY as string
    if (!siteKey) return ""

    await new Promise<void>((resolve) => {
      const check = () => {
        if (ready.current && typeof window.grecaptcha !== "undefined") {
          resolve()
        } else {
          setTimeout(check, 100)
        }
      }
      check()
    })

    return new Promise<string>((resolve) => {
      window.grecaptcha.enterprise.ready(() => {
        window.grecaptcha.enterprise.execute(siteKey, { action }).then(resolve)
      })
    })
  }, [])

  return { getToken }
}
